import React from "react";
import { FeatherAlertCircle } from "@subframe/core";
import { Badge } from "../../ui";
import { OwnersContributionCategoryDetails } from "../../services/api";

interface CustomerOwnersContributionViewContentProps {
  details: OwnersContributionCategoryDetails | null;
  isLoading: boolean;
}

const formatDate = (value?: string) => {
  if (!value) return "—";
  const date = new Date(value);
  return isNaN(date.getTime()) ? "—" : date.toLocaleDateString();
};

const InfoCard: React.FC<{ label: string; value: React.ReactNode }> = ({
  label,
  value,
}) => (
  <div className="flex flex-col rounded border border-neutral-border bg-white px-4 py-3">
    <span className="text-caption text-subtext-color">{label}</span>
    <span className="text-body-bold text-default-font">{value || "—"}</span>
  </div>
);

const CustomerOwnersContributionViewContent: React.FC<
  CustomerOwnersContributionViewContentProps
> = ({ details, isLoading }) => {
  const hasDetails = Boolean(details);

  return (
    <div className="flex w-full flex-col gap-4 rounded-md border border-solid border-neutral-border bg-neutral-50 px-6 py-6">
      <div className="flex w-full items-center justify-between">
        <div className="flex flex-wrap items-center gap-3">
          <span className="text-heading-3 font-heading-3 text-default-font">
            Owners Contribution Details
          </span>
          <Badge variant="neutral">Owners Contribution</Badge>
        </div>
      </div>

      {isLoading ? (
        <div className="flex w-full items-center justify-center py-12 text-body text-subtext-color">
          Loading transaction details...
        </div>
      ) : !hasDetails ? (
        <div className="flex w-full flex-col items-center gap-2 rounded border border-dashed border-neutral-border px-4 py-6 text-center text-body text-subtext-color">
          <FeatherAlertCircle className="text-neutral-400" />
          <span>No owners contribution details available.</span>
        </div>
      ) : (
        <div className="grid gap-4 md:grid-cols-2">
          <InfoCard
            label="From Account"
            value={details?.from_account_name || "—"}
          />
          <InfoCard label="Date" value={formatDate(details?.date)} />
          <InfoCard
            label="Received Via"
            value={details?.payment_mode || "—"}
          />
          <InfoCard
            label="Reference Number"
            value={details?.reference_number || "—"}
          />
        </div>
      )}
    </div>
  );
};

export default CustomerOwnersContributionViewContent;

